export const GET_USERS = 'admin/listUsers';

export const DELETE_USERS = 'admin/deleteUser';

export const BLOCK_USERS = 'admin/enableDisabledUser';

export const APPROVE_USER_DETAILS = 'admin/auth/userApproved';

export const POST_USER_DETAILS = 'admin/auth/signupUser';